.page {
  padding: 1.5rem 2rem 3rem;
  max-width: 52rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.home {
  color: var(--muted);
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
}

.question {
  font-family: var(--font-display);
  font-size: 1.4rem;
  margin: 0;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--muted);
  margin: 0.25rem 0 0;
}

.note {
  color: var(--muted);
}

.error {
  color: var(--stop);
}

.compare {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.compareWide {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
}
